__turbopack_context__.v({
  "containerMaxWidth": "search-bar-module-scss-module__8kuBvW__containerMaxWidth",
  "groupDivider": "search-bar-module-scss-module__8kuBvW__groupDivider",
  "groupHeading": "search-bar-module-scss-module__8kuBvW__groupHeading",
  "inlineIcon": "search-bar-module-scss-module__8kuBvW__inlineIcon",
  "searchBarButton": "search-bar-module-scss-module__8kuBvW__searchBarButton",
  "searchBarContainer": "search-bar-module-scss-module__8kuBvW__searchBarContainer",
  "searchBarSelect": "search-bar-module-scss-module__8kuBvW__searchBarSelect",
  "searchIcon": "search-bar-module-scss-module__8kuBvW__searchIcon",
  "searchToggles": "search-bar-module-scss-module__8kuBvW__searchToggles",
  "searchWrapper": "search-bar-module-scss-module__8kuBvW__searchWrapper",
  "toggleRow": "search-bar-module-scss-module__8kuBvW__toggleRow",
  "toggleSlider": "search-bar-module-scss-module__8kuBvW__toggleSlider",
});
